module.exports = __webpack_public_path__ + "static/img/banner-stiu.c2285ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-stiu.jpg
// module id = X2wc
// module chunks = 1